/**
 * AFS 1.1 annotation factories.
 *
 * Every factory accepts the user-supplied fields plus a captured
 * structural context (see `dom/captureAfsContext`) and emits a valid
 * `AfsAnnotation`.
 */
import { uuid } from "../util/id.js";
import { AFS_VERSION, } from "./afs.js";
const computeX = (anchorX) => {
    if (typeof window === "undefined" || window.innerWidth === 0)
        return 0;
    return Math.max(0, Math.min(100, (anchorX / window.innerWidth) * 100));
};
const computeY = (anchorY) => {
    if (typeof window === "undefined")
        return anchorY;
    return anchorY + window.scrollY;
};
export const createAfsAnnotation = (input) => {
    const now = Date.now();
    const ctx = input.context;
    return {
        id: uuid(),
        schemaVersion: AFS_VERSION,
        comment: input.comment,
        elementPath: ctx.elementPath,
        timestamp: now,
        x: computeX(ctx.anchor.x),
        y: computeY(ctx.anchor.y),
        element: ctx.element,
        ...(ctx.url ? { url: ctx.url } : {}),
        ...(ctx.boundingBox ? { boundingBox: ctx.boundingBox } : {}),
        ...(ctx.reactComponents ? { reactComponents: ctx.reactComponents } : {}),
        ...(ctx.cssClasses ? { cssClasses: ctx.cssClasses } : {}),
        ...(ctx.computedStyles ? { computedStyles: ctx.computedStyles } : {}),
        ...(ctx.accessibility ? { accessibility: ctx.accessibility } : {}),
        ...(ctx.nearbyText ? { nearbyText: ctx.nearbyText } : {}),
        ...(ctx.selectedText ? { selectedText: ctx.selectedText } : {}),
        ...(ctx.isFixed !== undefined ? { isFixed: ctx.isFixed } : {}),
        ...(input.isMultiSelect ? { isMultiSelect: input.isMultiSelect } : {}),
        ...(ctx.fullPath ? { fullPath: ctx.fullPath } : {}),
        ...(ctx.nearbyElements ? { nearbyElements: ctx.nearbyElements } : {}),
        ...(input.intent ? { intent: input.intent } : {}),
        ...(input.severity ? { severity: input.severity } : {}),
        kind: input.kind ?? "feedback",
        status: "pending",
        ...(input.placement ? { placement: input.placement } : {}),
        ...(input.rearrange ? { rearrange: input.rearrange } : {}),
        ...(input.attachments &&
            (input.attachments.screenshot || input.attachments.outerHTML)
            ? { attachments: input.attachments }
            : {}),
    };
};
//# sourceMappingURL=factory.js.map